import React from 'react';
import styles from './ErrorPage.scss';

const ErrorPage = ({
    subtitle = 'Something went wrong.',
    showReloadButton = true,
    showBackButton = false,
    onReload,
    onBack,
    isFullPage = true,
    className = '',
    'data-testid': dataTestId,
}) => {
    const handleReload = () => {
        if (onReload) {
            onReload();
        } else {
            window.location.reload();
        }
    };

    const handleBack = () => {
        if (onBack) {
            onBack();
        } else {
            window.history.back();
        }
    };

    return (
        <div className={`${styles['error-page-container']} ${isFullPage ? styles['error-page-full'] : ''} ${className} theme-v2`} data-testid={dataTestId}>
            <div className={styles['error-page-content']}>
                <div className={styles['error-page-image']}>
                    <img
                        src="/img/oops.png"
                        alt="Oops!"
                        className={styles['error-page-img']}
                        data-testid={dataTestId ? `${dataTestId}.image` : undefined}
                    />
                </div>
                <div className={styles['error-page-text']}>
                    <p className={styles['error-page-subtitle']} data-testid={dataTestId ? `${dataTestId}.subtitle` : undefined}>{subtitle}</p>
                </div>
                <div className={styles['error-page-actions']}>
                    {showReloadButton && (
                        <button
                            className="btn btn-primary btn-small text-uppercase"
                            onClick={handleReload}
                            data-testid={dataTestId ? `${dataTestId}.reload-btn` : undefined}
                        >
                            Try again
                        </button>
                    )}
                    {showBackButton && (
                        <button
                            className="btn btn-primary btn-small text-uppercase"
                            onClick={handleBack}
                            data-testid={dataTestId ? `${dataTestId}.back-btn` : undefined}
                        >
                            Click here to go back
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
